var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartvitalsreport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07731 18.628H24.0086M22.8833 0.599609H26.4844V4.19406M4.20265 0.599609H0.601562V4.19406M4.20265 26.4347H0.601562V22.8403M22.8833 26.4347H26.4844V22.8403M21.139 15.2582C20.5201 17.3363 19.2822 17.6171 19.2822 17.6171C19.2822 17.6171 19.1134 19.4705 18.8321 19.976C18.3257 21.0431 16.3563 22.728 15.1747 23.1211C15.0059 23.1773 14.2744 23.4019 13.543 23.4019C12.8115 23.4019 12.08 23.1773 11.9112 23.1211C10.7296 22.7841 8.81654 21.0431 8.25387 19.976C7.97254 19.4705 7.80374 17.6171 7.80374 17.6171C7.80374 17.6171 6.5096 17.3363 5.94693 15.2582C5.21546 12.8432 6.73466 13.2364 6.73466 13.2364C6.73466 13.2364 5.32799 8.63097 8.70401 5.54198C10.5046 3.85708 12.5302 3.68859 13.543 3.68859C14.5558 3.63243 16.5814 3.85708 18.3819 5.54198C21.7579 8.63097 20.3513 13.2364 20.3513 13.2364C20.3513 13.2364 21.8705 12.7871 21.139 15.2582Z",
    stroke: "#004276",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartvitalsreport);
export default __webpack_public_path__ + "static/media/smart vitals report.391a6e660cf046d4b047d88bb4f0dd05.svg";
export { ForwardRef as ReactComponent };